import { AppConfig } from '@app/core/models/app-config';
import { AppInfo } from '@app/core/models/app-info';
import { Action } from '@ngrx/store';

export enum ConfigActionTypes {
  FetchAppConfig = '[Config] Fetch App Config',
  FetchAppConfigSuccess = '[Config] Fetch App Config Success',
  FetchAppInfo = '[Config] Fetch App Info',
  FetchAppInfoSuccess = '[Config] Fetch App Info Success'
}

export class FetchAppConfig implements Action {
  readonly type = ConfigActionTypes.FetchAppConfig;
}

export class FetchAppConfigSuccess implements Action {
  readonly type = ConfigActionTypes.FetchAppConfigSuccess;
  constructor(public payload:  AppConfig) {}
}

export class FetchAppInfo implements Action {
  readonly type = ConfigActionTypes.FetchAppInfo;
}

export class FetchAppInfoSuccess implements Action {
  readonly type = ConfigActionTypes.FetchAppInfoSuccess;
  constructor(public payload: AppInfo) {}
}

export type ConfigActions =
  | FetchAppConfig
  | FetchAppConfigSuccess
  | FetchAppInfo
  | FetchAppInfoSuccess;
